module.exports = "<nm-page-header header=\"Email template list\"></nm-page-header>\n<div class=\"search-and-new\" >\n\t<div class=\"row\">\n\t\t<div class=\"col-xs-12\">\n\t\t\t<a class=\"btn btn-sm btn-primary\" routerLink=\"/email-tpls/create\" >New email template</a>\n\t\t</div>\n\t</div>\n\n\n</div>\n<div class=\"space-6\"></div>\n\n<div class=\"row\">\n\t\n\t<div class=\"space-6\"></div>\n\t<div class=\"col-xs-12\">\n\t\t<nm-datatable [settings]=\"datatableSetting\"></nm-datatable>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/pages/configs/email-tpls/list/list.html
// module id = 502
// module chunks = 0